import React from "react";
import { EventButton } from "../common";

const DrawResultLost = ({ onGoHome }) => {
  return (
    <div className="newyear-draw-result newyear-draw-result--lost">
      <div className="newyear-draw-result__icon">
        <span className="newyear-draw-result__emoji">
          &#128546;
        </span>
      </div>

      <h2 className="newyear-draw-result__title">아쉽습니다</h2>
      <p className="newyear-draw-result__message">
        이번 추첨에서는 당첨되지 않았습니다.
      </p>

      <p className="newyear-draw-result__sub-message">
        다음 이벤트에서 행운을 빕니다!
      </p>

      {onGoHome && (
        <div className="newyear-draw-result__actions">
          <EventButton
            variant="secondary"
            size="large"
            fullWidth
            onClick={onGoHome}
          >
            홈으로 돌아가기
          </EventButton>
        </div>
      )}
    </div>
  );
};

export default DrawResultLost;
